export default "__VITE_ASSET__Bo0LLVb1__"